// src/containers/navbar/index.js
import React, { useState, useEffect } from 'react';
import { Container, Row, Col, FormGroup } from 'reactstrap';
import InputBox from '../../components/common/input/index';
import Menu from '../menu/index';
import Image from '../../components/common/image/index';
import { X, Search } from 'react-feather';
import { Title } from '../../components/common/title/index';
import Login from './login';
import CartIcon from '../../components/CartIcon';
import CartDrawer from '../../cart/CartDrawer';
import './navbar.scss';

const logo = '/assets/images/Logo.png'; // served from CRA's public/ folder

export default function Navbar() {
  const [activeClass, setActiveClass] = useState(false);
  const [isSearchOpen, setSearchOpen] = useState(false);
  const [isLoginOpen, setLoginOpen] = useState(false);
  const [isCartOpen, setCartOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setActiveClass(window.scrollY !== 0);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div className="sbl-header-wrapper">
      <header className={`header-sticky ${activeClass ? 'sticky' : ''}`}>
        <Container>
          <Row>
            <Col sm={6} className="left-block">
              <div className="logo-wrapper">
                <a href="/"><Image Path={logo} Class="logo-img" /></a>
              </div>
            </Col>
            <Col sm={6} className="right-block">
              <div className="search-menu-account-wrapper">
                <div className="menu-right-1">
                  <div className="search-wrapper">
                    <div className="search-header" onClick={() => setSearchOpen(v => !v)}>
                      <Search />
                    </div>
                    <div className={`search-outer-wrapper ${isSearchOpen ? 'open' : ''}`}>
                      <div className="search-close gradient-color" onClick={() => setSearchOpen(false)}>
                        <X />
                      </div>
                      <div className="search-title-box">
                        <Title Class="search-title" Name="Search Panel" />
                        <div className="search-box">
                          <FormGroup>
                            <InputBox Type="text" Name="search" PlaceHolder="Search items" />
                          </FormGroup>
                          <span className="search-icon"><Search /></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <CartIcon onClick={() => setCartOpen(true)} />
                <Menu onLoginClick={() => setLoginOpen(true)} />
              </div>
            </Col>
          </Row>
        </Container>
      </header>

      {isLoginOpen && (
        <div className="login-modal-overlay">
          <Login Click={() => setLoginOpen(false)} />
        </div>
      )}

      <CartDrawer open={isCartOpen} onClose={() => setCartOpen(false)} />
    </div>
  );
}
